import "./AppSidebar.scss"
import get from "lodash/get"
import React from "react"
import { observer } from "mobx-react"
import { authStore } from "../stores"
import { NavLink, withRouter } from "react-router-dom"
import Icon from "./Icon"

const SidebarLink = props => {
  return (
    <NavLink
      {...props}
      className="SidebarLink"
      activeClassName="SidebarLink-active"
    />
  )
}

const AppSidebar = () => {
  return (
    <nav className="AppSidebar">
      <div className="Scroll">
        <div className="AppSidebar_header">
          <img
            className="AppSidebar_store_img"
            alt=""
            src={authStore.userStoreLogo}
          />
          <div>
            <p className="AppSidebar_store_prompt">
              <span role="img" aria-label="wave">
                👋
              </span>{" "}
              Welcome back,
            </p>
            <h5 className="AppSidebar_store_name">{authStore.store.name}</h5>
          </div>
        </div>
        <ul className="AppSidebar_links">
          <li>
            <SidebarLink to="/dashboard">
              <Icon name="bag" /> Dashboard
            </SidebarLink>
          </li>
          <li>
            <SidebarLink to="/products">
              <Icon name="product" /> Products
            </SidebarLink>
          </li>
          <li>
            <SidebarLink to="/store">
              <Icon name="store" /> Your Store
            </SidebarLink>
          </li>
          <li>
            <SidebarLink to="/payment">
              <Icon name="payment" /> Payment
            </SidebarLink>
          </li>
          <li>
            <SidebarLink to="/embed">
              <Icon name="code" /> Embed
            </SidebarLink>
          </li>
        </ul>
        <ul className="AppSidebar_footer">
          <li>
            <a onClick={authStore.logout} className="SidebarLink">
              <Icon name="logout" /> Logout
            </a>
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default withRouter(observer(AppSidebar))



// WEBPACK FOOTER //
// ./src/lib/AppSidebar.js